import React from "react";
import { requestSignedDownload } from "../../shared/downloads/requestSignedDownload";

function getExtension(filename) {
	var n = filename.lastIndexOf(".");
	var result = filename.substring(n + 1);
	return result;
}

function DownloadFile({ file }) {
	function handleDownload(event) {
		event.preventDefault();
		// Preserve the legacy auto-zip wrap for non-archive files. The file-search
		// staging stores most files as `<name>.csv.zip` on disk; raw .7z/.zip files
		// are served as-is.
		const ext = getExtension(file).toLowerCase();
		const wrappedName = ext === "7z" || ext === "zip" ? file : `${file}.zip`;
		requestSignedDownload({ filename: wrappedName });
	}

	return (
		<span>
			<button
				className="btn text-ccre-green-900 hover:underline"
				onClick={handleDownload}
			>
				Download
			</button>
		</span>
	);
}
export default DownloadFile;
